import {useEffect, useState} from 'react';
import {ICreateObjectData} from '../../common-code/interfaces/createData/ICreateObjectData';
import {KitchenService} from '../3d/services/KitchenService/KitchenService';
import {IModulePriceData} from '../../common-code/interfaces/catalog/IModulePriceData';
import {IMaterialData} from '../../common-code/interfaces/materials/IMaterialData';
import {IFacadeMaterialData} from '../../common-code/interfaces/materials/IFacadeMaterialData';
import {ISaveKUnitDetailData} from '../../common-code/interfaces/saveData/ISaveKUnitDetailData';
import {FACADE_MATERIAL_TYPE_MULTIPLE, GOOD_TYPE_APRON, GOOD_TYPE_TABLETOP} from '../../common-code/constants';
import {ISaveFacadeData} from '../../common-code/interfaces/saveData/ISaveFacadeData';

export default function useCreateOptions(
    objectData: ICreateObjectData,
    service: KitchenService,
    width?: number,
    corpusWidth?: number
) {
    const [createOptions, setCreateOptions] = useState<any>(service.getDefaultOptions(objectData, width, corpusWidth));

    useEffect(() => {
        setCreateOptions(service.getDefaultOptions(objectData, width, corpusWidth));
    }, [corpusWidth, objectData, objectData.options, service, width]);

    const setNewOptions = (fieldId: string, value: any, groupId?: string): boolean => {
        let newOptions = {...createOptions};
        let modulePrice: IModulePriceData;
        let corpusMaterial: IMaterialData | undefined;
        let facadeMaterial: IFacadeMaterialData | undefined;
        let index: string;

        if (groupId && newOptions[groupId]) {
            newOptions[groupId] = {...newOptions[groupId], [fieldId]: value};
        } else {
            newOptions[fieldId] = value;
        }
        if (newOptions.isSameWidthDepth &&
            groupId === 'corpus' && fieldId === 'width') {
            newOptions[groupId] = {...newOptions[groupId], depth: value};
        }
        if (fieldId === 'facadeMaterial') {
            modulePrice = service.calculateCreateObjectPrice(objectData, newOptions, width || corpusWidth);
            if (modulePrice.errors.length > 0) {
                corpusMaterial = service.findCreateObjectCorpusMaterialByFacadeMaterialId(
                    objectData,
                    newOptions,
                    value
                );
                if (corpusMaterial) {
                    newOptions.corpus = {...newOptions.corpus, material: corpusMaterial.id};
                }
            }
        }
        if (fieldId === 'multipleFacadeMaterial') {
            let facade: ISaveFacadeData;
            for (facade of newOptions.facades) {
                if (facade.facadeMaterialType === FACADE_MATERIAL_TYPE_MULTIPLE) {
                    facade.facadeMaterial = value;
                }
            }
        }
        if (fieldId === 'tabletopMaterial' && createOptions.tabletops) {
            let newTabletops: ISaveKUnitDetailData[] = [...createOptions.tabletops];
            for (index in newTabletops) {
                if (newTabletops[index].includeModulePrice) {
                    newTabletops[index] = {...newTabletops[index], material: '' + value};
                }
            }
            newOptions.tabletops = newTabletops;
        }
        if (groupId === 'corpus' && fieldId === 'material') {
            modulePrice = service.calculateCreateObjectPrice(objectData, newOptions, width || corpusWidth);
            if (modulePrice.errors.length > 0) {
                facadeMaterial = service.findCreateObjectFacadeMaterialByCorpusMaterialId(
                    objectData,
                    createOptions,
                    value
                );
                if (facadeMaterial) {
                    newOptions.facadeMaterial = facadeMaterial.id;
                }
            }
        }
        if (objectData.isAccessory) {
            if (groupId === 'sizes' && fieldId === 'height') {
                switch (objectData.catalogCode) {
                    case GOOD_TYPE_TABLETOP:
                        newOptions[groupId] = {...newOptions[groupId], [fieldId]: service.getTabletopHeight()};
                        break;
                    case GOOD_TYPE_APRON:
                        newOptions[groupId] = {...newOptions[groupId], [fieldId]: service.getApronHeight()};
                        break;
                }

            }
        }
        setCreateOptions(newOptions);

        return true;
    }
    return [createOptions, setNewOptions, setCreateOptions];
}